import { Component, Input } from '@angular/core';
import { PATHS } from 'shared/paths';
import { Article, Image } from 'shared/types';

@Component({
    selector: 'causes-tabs',
    templateUrl: './causes-tabs.component.html',
    styleUrls: ['./causes-tabs.component.scss'],
})
export class CausesTabsComponent {
    @Input() articles: Article[];
    @Input() mainArticle: Article;
    @Input() subArticle?: Article;
    @Input() nullArticle: Article;
    @Input() isNull: boolean;

    public articleImagesPath = PATHS.articleImages;
    public activeTabIndex = 0;

    public imgMaxHeight = 400;
    public scrollHeight = 400;

    public articleImageUrl(article?: Article): string | undefined {
        const image = this.getArticleImage(article);
        return image ? `${this.articleImagesPath}${image.url}-400.webp` : undefined;
    }

    public articleImageAlt(article?: Article): string {
        return this.getArticleImage(article)?.altText || '';
    }

    private getArticleImage(article?: Article): Image | undefined {
        return article?.images?.find(image => !!image?.url);
    }
}
